import * as React from 'react'

import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          '~flex ~h-[50px] ~w-full ~rounded-xs ~border ~border-input ~bg-background ~px-[10px] ~py-[13px] ~font-gibson ~text-base ~ring-offset-background file:~border-0 file:~bg-transparent file:~text-base file:~font-medium file:~text-foreground placeholder:~text-medium-grey focus-visible:~outline-none focus-visible:~ring-2 focus-visible:~ring-ring focus-visible:~ring-offset-2 disabled:~cursor-not-allowed disabled:~opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
